import { Box, Grid, styled, Typography, useMediaQuery } from "@mui/material";
import { YRFLogo } from "images";
import React, { useState } from "react";
import DocumentTitle from "react-document-title";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

const TermsContainer = styled("div")(({ theme }) => ({
  fontFamily: "'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  lineHeight: 1.8,
  color: "#333333",
  margin: 0,
  padding: 0,
}));

const HeaderSection = styled("header")(({ theme }) => ({
  backgroundColor: "#ffffff",
  borderBottom: "2px solid #f0f0f0",
  padding: "40px 20px",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    padding: "30px 15px",
  },
  "& img": {
    maxHeight: "150px",
    marginBottom: "20px",
  },
  "& h1": {
    margin: "20px 0 10px",
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#1a1a1a",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem",
    },
  },
}));

const MainContent = styled("main")(({ theme }) => ({
  maxWidth: "900px",
  margin: "0 auto",
  padding: "40px 30px",
  [theme.breakpoints.down("sm")]: {
    padding: "20px 15px",
  },
  "& h2": {
    fontSize: "1.3rem",
    fontWeight: 700,
    marginTop: "30px",
    marginBottom: "15px",
    color: "#1a1a1a",
    borderBottom: "2px solid #007bff",
    paddingBottom: "10px",
  },
  "& h3": {
    fontSize: "1.1rem",
    fontWeight: 600,
    marginTop: "20px",
    marginBottom: "12px",
    color: "#333333",
  },
  "& p": {
    marginBottom: "15px",
    textAlign: "justify",
    fontSize: "0.95rem",
  },
  "& ul, & ol": {
    marginLeft: "20px",
    marginBottom: "15px",
  },
  "& li": {
    marginBottom: "10px",
    textAlign: "justify",
  },
  "& strong": {
    fontWeight: 600,
    color: "#1a1a1a",
  },
  "& a": {
    color: "#007bff",
    textDecoration: "none",
    "&:hover": {
      color: "#007bff",
      textDecoration: "underline",
    },
  },
}));

const TermsCondition = () => {
  const navigate = useNavigate();

  return (
    <>
      <DocumentTitle title={"Terms & Condition"}>
        <>
          <Helmet>
            <link rel="stylesheet" type="text/css" href="css/styles.css" />
          </Helmet>
          <TermsContainer>
            <section id="logo-home">
              <img
                src={YRFLogo}
                style={{ height: "250px", width: "250px", borderRadius: "5px" }}
              />
            </section>
            <HeaderSection>
              {/* <img
                src={YRFLogo}
                alt="Luv Films Logo"
                style={{ height: "200px" }}
              /> */}

              <h1>TERMS OF USE</h1>
            </HeaderSection>

            <MainContent>
              <p>
                <strong>Luv Films LLP</strong> ("Luv Films") is pleased to
                provide to you access to its mobile application. These terms of
                use govern your use and our provision of the services on{" "}
                <a
                  href="https://casting.luvfilms.in/termsofservice"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://casting.luvfilms.in/termsofservice
                </a>{" "}
                ("our Platform"/ "the Platform").{" "}
                <strong>
                  PLEASE READ THESE TERMS OF USE ("TERMS") CAREFULLY BEFORE
                  ACCESSING, AVAILING AND/OR USING OUR PLATFORM.
                </strong>
              </p>

              <h2>1. Contract between You and Us</h2>
              <p>
                This is a contract between you ("You"/"Your") and Luv Films, a
                limited liability partnership firm incorporated under the
                Limited Liability Partnership Act, 2008. You must read and agree
                to these Terms before using or accessing our Platform. You agree
                that by clicking "Login", "Sign Up" or similar, registering,
                accessing or using our Platform, You are agreeing to enter into
                a legally binding contract with Luv Films. Further, 'You' or
                'Your' shall without limitation include any organization,
                company or branch of government and the person availing or
                accessing on behalf of any such organization, company or branch
                of government hereby represents and warrants that they have the
                authority to legally bind the company or organization and
                company or organization to the obligations and restrictions of
                these Terms of Use. By accessing, availing and/or using our
                Platform You agree to be bound by these Terms of Use. If You do
                not agree to this contract ("Contract" or "Terms" or "Terms of
                Use"), do not click "Login", "Sign Up" (or similar) and do not
                access or otherwise use the Platform. If You wish to terminate
                this contract, at any time You can do so by no longer accessing
                or using our Platform. These Terms supersede prior agreements or
                arrangements.
              </p>

              <p>
                Use of our Platform is available only to persons who can form a
                legally binding contract under the Indian Contract Act, 1872 and
                who are not disqualified or declared incompetent under the
                Indian Contract Act, 1872.
              </p>

              <p>
                Supplemental terms and conditions may apply to our Platform,
                such as rules for a particular service or other activity, or
                terms that may accompany certain content accessible through our
                Platform. Supplemental terms and conditions will be disclosed to
                You in connection with the applicable service or activity. Any
                supplemental terms and conditions are in addition to these
                terms, and in the event of a conflict, prevail over these Terms.
              </p>

              <p>
                Luv Films may amend these Terms at Luv Films' sole discretion
                and make best efforts to notify You when major changes are made.
                Your continued use of our Platform following the posting of
                changes and/or modifications will constitute Your acceptance of
                the revised Terms. Nothing in these Terms shall be deemed to
                confer any third-party rights or benefits upon You.
                Notwithstanding the above, if any change to these Terms is found
                invalid, void, or for any reason unenforceable, that change is
                severable and does not affect the validity and enforceability of
                any remaining changes or conditions.
              </p>

              <p>
                Luv Films may immediately terminate this contract with respect
                to You (including Your access to the our Platform) if You fail
                to comply with any provision of these Terms. These Terms, and
                any posted revisions, shall remain in effect while You use the
                Platform, however certain provisions may continue to apply even
                after termination.
              </p>

              <p>
                You undertake and warrant that You will periodically review the
                Terms provided at{" "}
                <a
                  href="https://casting.luvfilms.in/termsofservice"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://casting.luvfilms.in/termsofservice
                </a>{" "}
                and that Your consent to the same shall be construed by the
                continuous access or use of the Platform.
              </p>

              <h2>2. Purpose</h2>
              <p>
                Our Platform is designed for professional use, solely in the
                context of seeking casting opportunities with Luv Films.
              </p>

              <p>
                You agree, acknowledge, and confirm that any data and/or
                requests submitted by you through the Platform have been
                provided by you, on a voluntary basis. You further acknowledge
                that the mere submission of any data and/or requests by you on
                the Platform, do not, in any way amount to any guarantee or
                assurance of casting call backs, offers, or other acceptance by
                Luv Films, for any role or otherwise.
              </p>

              <p>
                To register on the Platform, and avail our Services, you must be
                of at least 18 years of age and have the capacity to enter into
                this agreement.
              </p>

              <p>
                You hereby confirm that all the information furnished is
                truthful and accurate, and does not suffer from any
                deficiencies.
              </p>

              <p>
                For creation of an account, registration on the Platform, you
                will have to provide a valid mobile number, and you shall
                receive an OTP, for authentication and validation of your
                profile. This profile created on the Platform, will be available
                for your exclusive access, and you would be able to interact
                with us, upload requisite data, and avail such other Services
                which are functional on the Platform. You are responsible for
                safeguarding your account and agree not to disclose your login
                details to anyone. Services on the Platform, will only become
                available to you, upon successful completion and registration on
                the Platform.
              </p>

              <p>
                You agree that you shall be solely responsible for any
                activities or actions made through your account. You will
                immediately notify the Company of any unauthorized use of your
                account, upon becoming aware of any such discrepancy. Without
                limiting any other terms of this Terms, you may not use false
                identities or impersonate any other person or use a username or
                phone number that you are not authorized to use.
              </p>

              <p>
                You hereby agrees to indemnify and hold harmless and keep
                indemnified Luv Films and its assignees/licensees from and
                against any and all loss, damages, claims arising from or out of
                or in connection with (a) any obligation, representation,
                warranty, undertaking or covenant hereby made/agreed/undertaken
                by You under these Terms turning out to be false, untrue,
                misleading, incorrect and/or breached; (b) any third party
                claims including but not limited to the intellectual property
                rights of a third party; (c) Your use of and access to the
                Platform, including any data or content transmitted or received
                by You; (d) Your violation of any third-party right, including
                without limitation any right of privacy or intellectual property
                rights; (e) Your violation of any applicable law, rule or
                regulation; (f) any claims or damages that arise as a result of
                any of Your content that is submitted by You on the Platform or
                otherwise; (vi) any other party's access and use of our Platform
                with Your information, IP address or other appropriate security
                code.
              </p>

              <p>
                You acknowledge and agree that Luv Films will collect and
                receive personally identifiable information submitted by You,
                including without limitation, Your telephone number, Permanent
                Account Number and/or Aadhar Number, social media links and such
                information will be used by Luv Films for purposes of performing
                its obligations under these Terms. Such information may include
                Your name, age, gender, phone number, physical address and
                details of Your mobile device.
              </p>

              <p>
                You further acknowledge and agree that Luv Films may disclose,
                at its sole discretion, such information to its affiliates for
                the purpose stated hereunder and You shall have no objection
                and/or claim against Luv Films in respect thereof.
              </p>

              <p>
                Luv Films does not verify, endorse or take responsibility for
                the accuracy, completeness or quality of the material or content
                contained on the Platform. Furthermore, Luv Films is not
                responsible for the quality of or delivery of any services
                offered, accessed, obtained by or advertised via the Platform.
                All trademarks, service marks, trade names, trade dress and
                other intellectual property rights on our Platform are owned by
                us or our licensors or licensees or any affiliate companies.
                Except as we specifically agree in writing, no element of our
                Platform may be used or exploited in any way. We do not transfer
                title to any portion of the our Platform to You. Nothing
                provided by any brand owned or licensed by Luv Films should be
                construed as granting, by implication, estoppels or otherwise,
                any license or right of use of any trademark displayed on our
                Platform without the written permission of Luv Films.
              </p>

              <p>
                You agree to provide and maintain accurate, current and complete
                information, including Your contact information for notices and
                other communications from us. You shall provide Luv Films with
                Your complete details to create a profile. You agree to inform
                Luv Films immediately of any changes to the information that You
                provided when registering. You agree not to impersonate or
                misrepresent Your affiliation with any person or entity,
                including using another person's username, password or other
                account information, or another person's name or likeness. You
                agree that Luv Films may take steps to verify the accuracy of
                information You provide. You may never use another's account
                without permission. You undertake not to impersonate any person
                or entity, falsely state or otherwise misrepresent Your
                affiliation with a person or entity or disguise the origin of
                any content, stalk or otherwise harass another person or upload,
                post or e-mail any content that You do not have a right to
                transmit under any law or under contractual or fiduciary
                relationships, upload, post or e-mail any content that infringes
                any intellectual property rights or other third party rights of
                any party or violate any applicable national or international
                laws or regulations.
              </p>

              <h2>3. Eligibility, Application Process and Selection Flow</h2>
              <h3>a. Who can apply:</h3>
              <p>
                The casting call available on the Platform for the current Luv
                Films project is open to male and female applicants with an
                on‑screen age of 21-29 years, or such other age range as may be
                notified on the Platform from time to time. Only newcomers are
                intended to be considered for this project; however, applicants
                who have previously worked in television, advertisements, films,
                or as influencers/content creators may also apply, provided they
                otherwise meet the eligibility criteria and these Terms.
              </p>

              <h3>b. Application process:</h3>
              <p>
                All applications must be submitted exclusively through the
                Platform. Applications will be accepted only through online
                submission; no physical, email, or social‑media submissions will
                be entertained. There shall be no on‑ground or walk‑in auditions
                at the initial stage, and any communication to the contrary not
                issued by Luv Films through its official channels should be
                treated as unauthorised.
              </p>

              <h3>c. Submission requirements:</h3>
              <p>
                Applicants must submit 4 (four) photographs and 3 (three)
                self‑test videos, strictly in the format and as per the scripts
                and technical specifications provided on the Platform
              </p>

              <h3>d. Selection flow (indicative):</h3>
              <p>
                Without creating any obligation on Luv Films to follow any
                specific structure, the proposed selection process for the
                current project may include: (i) an initial online screening of
                applications and submitted materials; (ii) in‑person auditions
                of shortlisted candidates in Mumbai (or such other location as
                may be notified); (iii) further shortlisting and/or call‑backs;
                and (iv) final selection of candidates, which may include
                selection of approximately 3 (three) male and 3 (three) female
                actors, or such other number as Luv Films may determine at its
                sole discretion. Luv Films may modify, add, or remove any stage
                of the casting process at any time, and nothing in these Terms
                shall be construed as creating any right or guarantee of
                shortlisting, audition, or selection for any applicant.
              </p>

              <h2>4. Electronic Communications</h2>
              <p>
                When You use our Platform, or send e-mails to us, You are
                communicating with us electronically. You consent to receive
                communications from us electronically. We will communicate with
                You by e-mail, SMS, phone call or by posting notices on this
                Platform. You agree that all agreements, notices, disclosures
                and other communications that we provide to You electronically
                satisfy any legal requirement that such communications be in
                writing. You further acknowledge and agree that any such
                communication, by phone or SMS, would constitute a
                "Transactional Message" as per the Telecom Commercial
                Communication Customer Preference Regulations, 2010, notified by
                the Telecom Regulatory Authority of India.
              </p>

              <h3>Collection and Storage of Information</h3>
              <p>
                Luv Films may collect, directly from You and/or from a
                third-party source, and thereafter store, inter alia, all the
                information provided to us when You register on the Platform
                ("Information").
              </p>

              <p>
                Depending on the circumstances, Information may constitute
                Sensitive Personal Data or Information ("SPDI"), as defined in
                the Information Technology (Reasonable Security Practices and
                Procedures and Sensitive Personal Data or Information) Rules,
                2011 ("Privacy Rules"), and would be collected, stored,
                processed, transferred, disclosed and destroyed in accordance
                with the Luv Film's privacy policy ("Privacy Policy"). By using
                the Platform and/or by clicking accept, You expressly consent to
                the collection/use/ transfer of Your Information in accordance
                with these Terms and the Privacy Policy.
              </p>

              <h3>Transfer of Information</h3>
              <p>
                The Company may transfer and/or disclose Your Information to its
                affiliates, group entities for the limited purpose of providing
                the services on the Platform. Information will be transferred in
                accordance with applicable laws, and only to entities and
                jurisdictions which ensure the same or greater level of data
                protection that is adhered to by the Company under the Privacy
                Rules.
              </p>

              <p>
                By using the Platform, and by clicking accept, You expressly
                consent to the transfer and disclosure of Your Information to
                Luv Films and its affiliates. You further agree and acknowledge
                that such transfer is necessary for the performance of the
                Platform.
              </p>

              <h2>5. Your Conduct</h2>
              <p>
                You must not use our Platform in any way that causes, or is
                likely to cause, the Platform or access to it to be interrupted,
                damaged or impaired in any way. You understand that You, and not
                Luv Films, is responsible for all electronic communications and
                content sent from Your device to Luv Films and You must use the
                Platform for lawful purposes only. You must not use the Platform
                for any of the following:
              </p>

              <ul>
                <li>
                  For fraudulent purposes, or in connection with a criminal
                  offense or other unlawful activity;
                </li>
                <li>
                  To upload, send, use or reuse any material that does not
                  belong to You; or is illegal, offensive (including but not
                  limited to material that is sexually explicit content or which
                  promotes racism, bigotry, hatred or physical harm), deceptive,
                  misleading, abusive, indecent, harassing, blasphemous,
                  defamatory, libelous, obscene, pornographic, pedophilic or
                  menacing; ethnically objectionable, disparaging or in breach
                  of copyright, trademark, confidentiality, privacy or any other
                  proprietary information or right; or is otherwise injurious to
                  third parties; or relates to or promotes money laundering or
                  gambling; or is harmful to minors in any way; or impersonates
                  another person; or threatens the unity, integrity, security or
                  sovereignty of India or friendly relations with foreign
                  States; or objectionable or otherwise unlawful in any manner
                  whatsoever; or which consists of or contains software viruses,
                  political campaigning, commercial solicitation, chain letters,
                  mass mailings or any spam;
                </li>
                <li>To cause annoyance and/or inconvenience;</li>
                <li>
                  Create a false identity, misrepresent Your identity, create a
                  profile for anyone other than Yourself (a real person), or use
                  or attempt to use another's account;
                </li>
                <li>
                  Develop, support or use software, devices, scripts, robots, or
                  any other means or processes (including crawlers, browser
                  plugins and add-ons, or any other technology) to scrape our
                  Platform or otherwise copy profiles and other data from our
                  Platform.
                </li>
                <li>
                  Override any security feature or bypass or circumvent any
                  access controls or use limits of our Platform (such as caps on
                  keyword searches or profile views);
                </li>
                <li>
                  Copy, use, disclose or distribute any information obtained
                  from the Luv Films services, whether directly or through third
                  parties (such as search engines), without the consent of Luv
                  Films;
                </li>
                <li>
                  Disclose information that You do not have the consent to
                  disclose (such as confidential information of others
                  (including Your employer);
                </li>
                <li>
                  Use bots or other automated methods to access our Platform,
                  add or download contacts, send or redirect messages;
                </li>
                <li>
                  Monitor our Platform's performance or functionality for any
                  competitive purpose;
                </li>
                <li>
                  Engage in "framing", "mirroring", or otherwise simulating the
                  appearance or function of our Platform.
                </li>
              </ul>

              <h2>6. Disclaimers and Limitation on Liability</h2>
              <p>
                <strong>
                  THE INFORMATION AND CONTENT AVAILABLE ON THE PLATFORM ARE
                  PROVIDED "AS IS" AND "AS AVAILABLE." WE DISCLAIM ALL
                  CONDITIONS, REPRESENTATIONS AND WARRANTIES NOT EXPRESSLY SET
                  OUT IN THESE TERMS.
                </strong>
              </p>

              <p>
                <strong>
                  TO THE EXTENT PERMITTED BY LAW, WE AND OUR ASSIGNIES,
                  LICENSEES AND AFFILIATES DISCLAIM IMPLIED WARRANTIES THAT LUV
                  FILMS AND ALL SOFTWARE, CONTENT DISTRIBUTED THROUGH LUV FILMS
                  ARE MERCHANTABLE, OF SATISFACTORY QUALITY, ACCURATE, TIMELY,
                  FIT FOR A PARTICULAR PURPOSE OR NEED, OR NON-INFRINGING. WE DO
                  NOT GUARANTEE THAT LUV FILMS WILL MEET YOUR REQUIREMENTS, IS
                  ERROR-FREE, RELIABLE, WITHOUT INTERRUPTION OR AVAILABLE AT ALL
                  TIMES. WE DO NOT GUARANTEE THAT THE RESULTS THAT MAY BE
                  OBTAINED FROM THE USE OF LUV FILMS, INCLUDING ANY SUPPORT
                  SERVICES, WILL BE EFFECTIVE, RELIABLE, ACCURATE OR MEET YOUR
                  REQUIREMENTS. WE DO NOT GUARANTEE THAT YOU WILL BE ABLE TO
                  ACCESS OR USE LUV FILMS (EITHER DIRECTLY OR THROUGH
                  THIRD-PARTY NETWORKS) AT TIMES OR LOCATIONS OF YOUR CHOOSING.
                  NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY LUV FILMS
                  REPRESENTATIVE SHALL CREATE A WARRANTY.
                </strong>
              </p>

              <p>
                <strong>
                  WE SHALL NOT BE LIABLE TO YOU FOR DIRECT, INDIRECT,
                  INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES OR ANY
                  OTHER DAMAGES OF ANY KIND, INCLUDING BUT NOT LIMITED TO LOST
                  PROFITS, REVENUE OR SAVINGS OR OTHER ECONOMIC LOSS, LOSS OF OR
                  DAMAGE TO DATA OR LOSS OF BUSINESS OR GOODWILL AND OR PROPERTY
                  DAMAGE, EVEN IF WE WERE ADVISED OF THE POSSIBILITY OF SUCH
                  DAMAGES, NOR SHALL WE BE HELD LIABLE FOR DELAY OR FAILURE IN
                  PERFORMANCE RESULTING FROM CAUSES BEYOND OUR REASONABLE
                  CONTROL.
                </strong>
              </p>

              <p>
                <strong>
                  IF YOU ARE DISSATISFIED WITH OUR PLATFORM, OR WITH THESE
                  TERMS, YOUR SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE
                  ACCESSING OR USING OUR PLATFORM.
                </strong>
              </p>

              <p>
                <strong>
                  LUV FILMS MAKES NO REPRESENTATION THAT MATERIALS, CONTENT ON
                  THE PLATFORM ARE APPROPRIATE OR AVAILABLE FOR USE IN OTHER
                  LOCATIONS. THOSE WHO CHOOSE TO ACCESS THIS PLATFORM FROM OTHER
                  LOCATIONS DO SO ON THEIR OWN INITIATIVE AND ARE RESPONSIBLE
                  FOR COMPLIANCE WITH LOCAL LAWS, IF AND TO THE EXTENT LOCAL
                  LAWS ARE APPLICABLE.
                </strong>
              </p>

              <p>
                <strong>
                  YOU ACKNOWLEDGE AND UNDERTAKE THAT YOU ARE ACCESSING THE
                  SERVICES ON THE PLATFORM AND TRANSACTING AT YOUR OWN RISK AND
                  ARE USING YOUR BEST AND PRUDENT JUDGMENT BEFORE ENTERING INTO
                  OUR PLATFORM. WE SHALL NEITHER BE LIABLE NOR RESPONSIBLE FOR
                  ANY ACTIONS OR INACTIONS OF USERS NOR ANY BREACH OF
                  CONDITIONS, REPRESENTATIONS OR WARRANTIES BY THE USERS AND
                  HEREBY EXPRESSLY DISCLAIM AND ANY ALL RESPONSIBILITY AND
                  LIABILITY IN THAT REGARD.
                </strong>
              </p>

              <p>
                <strong>
                  WE MAKE NO REPRESENTATIONS OR GUARANTEES THAT OUR PLATFORM
                  WILL BE FREE FROM ANY ATTACK, ANY INTERRUPTION OR CESSATION OF
                  TRANSMISSION TO OR OF OUR PLATFORM, UNAUTHORISED ACCESS TO
                  SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION, ANY
                  BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE
                  TRANSMITTED TO OR THROUGH OUR PLATFORM BY ANY THIRD PARTY,
                  AND/OR ANY ERRORS OR OMISSIONS IN ANY CONTENT OR FOR ANY LOSS
                  OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY
                  CONTENTS POSTED, EMAILED, TRANSMITTED, OR OTHERWISE MADE
                  AVAILABLE VIA OUR PLATFORM.
                </strong>
              </p>

              <p>
                <strong>
                  WE DO NOT WARRANT, ENDORSE, GUARANTEE, HAVE ANY CONTROL OVER
                  OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED
                  OR OFFERED BY A THIRD PARTY OR ANY HYPERLINKED SERVICES OR
                  FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND LUV FILMS
                  WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR
                  MONITORING ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY
                  PROVIDERS OF PRODUCTS OR SERVICES. YOU ARE ADVISED TO USE YOUR
                  BEST JUDGMENT AND EXERCISE CAUTION, WHILE ACCESSING SERVICE
                  ADVERTISED OR OFFERED BY A THIRD PARTY AND WE DISCLAIM ANY
                  LIABILITY RELATING THERETO.
                </strong>
              </p>

              <h2>7. Additional Restrictions on Use of the Platform</h2>
              <p>
                Your use of the Platform is subject to strict compliance with
                the following conditions, inter alia:
              </p>

              <ul>
                <li>
                  You acknowledge and agree that You shall not, directly or
                  indirectly, engage in the unauthorized use of any
                  copyright-protected materials on the Platform. This includes
                  storing, publicly performing, reproducing, modifying,
                  distributing, creating derivative works from, transmitting,
                  displaying, decompiling, reverse engineering, making
                  available, or otherwise communicating to the public any
                  content for which You do not possess the requisite rights, or
                  which may infringe upon third-party rights, including
                  intellectual property rights;
                </li>
                <li>
                  You shall not alter, modify, or interfere with any portion of
                  the Platform, nor use them for any unlawful or unauthorized
                  purposes; You shall not reformat, frame, or otherwise
                  replicate any part of the Platform;
                </li>
                <li>
                  You agree not to knowingly or recklessly introduce a virus or
                  other harmful component, or otherwise tamper with, impair or
                  damage our Platform or connected network, or interfere with
                  any person or entity's use or enjoyment of our Platform.
                  Additionally, You agree not to access, monitor or copy any
                  element of our Platform using a robot, spider, scraper or
                  other automated means or manual process without our express
                  written permission;
                </li>
                <li>
                  You agree not to use or launch any automated system, including
                  without limitation, "robots", "data mining tools", "spiders",
                  "offline readers" or "manual processes" that accesses our
                  Platform in a manner that sends more request messages to Luv
                  Films' servers in a given period of time than a human can
                  reasonably produce in the same period by using a conventional
                  on-line web browser and/or to access, extract, monitor, cache,
                  copy, frame, or distribute any content from the Platform,
                  except as part of standard browsing or legitimate search
                  engine use. Notwithstanding the foregoing, Luv Films grants
                  the operators of public search engines permission to use
                  spiders to copy materials from the Platform for the sole
                  purpose of and solely to the extent necessary for creating
                  publicly available searchable indices of the materials, but
                  not caches or archives of such materials. Luv Films reserves
                  the right to revoke these exceptions either generally or in
                  specific cases;
                </li>
                <li>
                  You shall not impersonate any individual or entity, whether
                  real or fictitious, nor misrepresent Your relationship or
                  affiliation with any person or organization;
                </li>
                <li>
                  You shall not alter, obscure, or remove any identification,
                  trademark, copyright or other proprietary notices on the
                  Platform or in any of its content. Use of any Luv Films' logo,
                  trademark, or proprietary design element in links or otherwise
                  requires Luv Films' prior express written consent;
                </li>
                <li>
                  You may not redistribute, circumvent or disable any content
                  protection system or digital rights management technology used
                  with our Platform; decompile, reverse engineer, disassemble or
                  otherwise reduce our Platform to a human-readable form; or
                  access or use our Platform in an unlawful or unauthorized
                  manner or in a manner that suggests an association with our
                  services or brands. By acquiring services or content through
                  our Platform, You represent and warrant that Your access to
                  and use of the services or content will comply with those
                  requirements;
                </li>
                <li>
                  You shall not upload, download, post, alter, reproduce, adapt,
                  repurpose, rent, lease, share, distribute, perform, transfer,
                  or otherwise use or exploit any content of the Platform in any
                  unauthorized manner, including by reverse engineering,
                  decompiling, or creating derivative works, except as expressly
                  permitted by law or applicable open-source license terms;
                </li>
                <li>
                  You are prohibited from retransmitting, disseminating,
                  selling, or otherwise making available the content, in whole
                  or in part, for any purpose—including personal or
                  non-commercial use—without Luv Films' prior written consent,
                  unless such restriction is invalid under applicable law or
                  exempted by license;
                </li>
                <li>
                  You must ensure full compliance with all applicable Indian
                  laws, including the Information Technology Act, 2000 and its
                  rules, as well as all relevant domestic and international
                  laws, as updated from time to time;
                </li>
                <li>
                  You acknowledge that Luv Film may disclose any information
                  provided by You on the Platform if required to comply with
                  legal obligations, regulations, or legitimate governmental
                  requests. You further expressly authorize Us to disclose Your
                  information to law enforcement or government authorities if
                  We, in Our sole discretion, believe it necessary in connection
                  with the investigation of any potential criminal activity.
                </li>
              </ul>

              <h2>8. Third Party Hyperlinks</h2>
              <p>
                The Platform may contain and/or provide access to third party
                websites that are not owned or controlled by Luv Films. The
                appearance of external hyperlinks and/or other elements
                generated by third parties on this Platform does not constitute
                endorsement by Luv Films and/or its affiliate companies of the
                opinions or views expressed by such third parties' websites. Luv
                Films does not verify, endorse or take responsibility for the
                accuracy, currency, completeness or quality of the content
                contained on these third parties' sites. Furthermore, Luv Films
                is not responsible for the quality of or delivery of any
                services offered, accessed, obtained by or advertised at such
                third parties' sites. As such, Luv Films will not be responsible
                for content provided on any third party website, and further Luv
                Films will under no circumstances be liable for any direct,
                indirect, incidental or special loss or other damage, whether
                arising from negligence, breach of contract, defamation,
                infringement of copyright or other intellectual property rights,
                caused by the exhibition, distribution or exploitation of any
                information or content contained within these third party
                hyperlinked websites.
              </p>

              <h2>9. Your Content and Account</h2>
              <h3>User Generated Content</h3>
              <p>
                The Platform may require You to communicate, submit, upload or
                otherwise make available text, images, videos, snippets of your
                audition tapes, details of previous work experience or other
                content ("User Generated Content"), which may be accessible and
                viewable by the public. You may not submit or upload User
                Generated Content that is unlawful, abusive, tortuous, profane,
                pedophilic, racially or ethnically or otherwise objectionable,
                defamatory, harassing, threatening, bigoted, hateful, violent,
                vulgar, obscene, pornographic, or otherwise offensive or that
                harms or can reasonably be expected to harm any person or
                entity, whether or not such material is protected by law.
              </p>

              <p>
                We do not claim ownership to Your User Generated Content;
                however, You grant us a non-exclusive, sub licensable,
                irrevocable perpetual and royalty-free worldwide license under
                all copyrights, trademarks, patents, trade secrets, privacy and
                publicity rights and other intellectual property rights to use,
                reproduce, transmit, print, publish, publicly display, exhibit,
                distribute, redistribute, copy, index, comment on, modify,
                adapt, make available and otherwise exploit, commercially or
                otherwise, such User Generated Content, in whole or in part, in
                all media formats now known or hereafter devised (including on
                third-party sites and platforms such as Facebook, Instagram,
                YouTube and Twitter), in any number of copies and without limit
                as to time, manner and frequency of use, without further notice
                to You, with or without attribution, and without the requirement
                of permission from or payment to You or any other person or
                entity. The User Generated Content may be subject to such
                additional terms and conditions provided by Luv Films at the
                time of submission.
              </p>

              <p>
                You represent and warrant that Your User Generated Content
                conforms to these Terms and that You own or have the necessary
                rights and permissions, without the need for payment to any
                other person or entity, to use and exploit, and to authorize us
                to use and exploit, Your User Generated Content in all manners
                contemplated by these Terms. You agree to indemnify and hold us
                and our subsidiary and affiliated companies, and each of their
                respective employees and officers, harmless from any demands,
                loss, liability, claims or expenses (including attorneys' fees),
                made against us by any third party arising out of or in
                connection with our use and exploitation of Your User Generated
                Content. You also agree not to enforce any moral rights,
                ancillary rights or similar rights in or to the User Generated
                Content against us or our licensees, distributors, agents,
                representatives and other authorized users, and agree to procure
                the same agreement not to enforce from others who may possess
                such rights. Luv Films reserves the right to decide whether the
                User Generated Content or any other content violates this Terms.
              </p>

              <h3>Claims against Objectionable Content</h3>
              <p>
                We operate on a "notice and takedown" basis. If You believe that
                any content on our Platform is illegal, offensive (including but
                not limited to material that is sexually explicit content or
                which promotes racism, bigotry, hatred or physical harm),
                deceptive, misleading, abusive, indecent, harassing,
                blasphemous, defamatory, libelous, obscene, pornographic,
                pedophilic or menacing; ethnically objectionable, disparaging;
                or is otherwise injurious to third parties; or relates to or
                promotes money laundering or gambling; or is harmful to minors
                in any way; or impersonates another person; or threatens the
                unity, integrity, security or sovereignty of India or friendly
                relations with foreign States; or objectionable or otherwise
                unlawful in any manner whatsoever; or which consists of or
                contains software viruses, (" Objectionable Content "), please
                notify us immediately by sending us a notice. Luv Films will
                make all reasonable endeavours to remove such Objectionable
                Content complained about within a reasonable time.
              </p>

              <h3>10. Communications and Other content</h3>
              <p>
                Users of our Platform may post digital assets, media, content,
                send communications, as long as the content is not illegal,
                obscene, abusive, threatening, defamatory, invasive of privacy,
                infringing of intellectual property rights, or otherwise
                injurious to third parties, or objectionable and does not
                consist of or contain software viruses, political campaigning,
                commercial solicitation, chain letters, mass mailings, or any
                form of "spam." In the event a user uses a false e-mail address,
                impersonates any person or entity, or otherwise misleads as to
                the origin of any content, Luv Films reserves the right (but not
                the obligation) to remove, refuse, delete or edit any content
                that in the sole judgment of Luv Films violates these Terms and,
                or terminate Your permission to access or use this Platform. If
                You do post content or submit material, and unless we indicate
                otherwise, You (a) grant Luv Films and its affiliates a
                non-exclusive, royalty-free, irrevocable, perpetual and fully
                sub licensable rights to use, reproduce, publish and display
                such content throughout the world in any media without any
                further obligation towards You; and (b) Luv Films and its
                affiliates and sub-licensees the right to use the name that You
                submit in connection with such content, if they choose.
              </p>

              <p>
                You agree that the rights You grant above are irrevocable during
                the entire period of protection of Your intellectual property
                rights associated with such content and material. You agree to
                waive Your right to be identified as the author of such content
                and Your right to object to derogatory treatment of such
                content. You agree to perform all further acts necessary to
                protect any of the above rights granted by You to Luv Films,
                including the execution of deeds and documents, at its request.
              </p>

              <p>
                You represent and warrant that You own or otherwise control all
                of the rights to the content that You provide on or through our
                Platform; that, as at the date that the content or material is
                submitted to Luv Films: (i) the content and material is
                accurate; (ii) use of the content and material You supply does
                not breach any applicable Luv Films r policies or guidelines and
                will not cause injury to any person or entity (including that
                the content or material is not defamatory); (iii) the content is
                lawful. You agree to indemnify Luv Films and its affiliates for
                all claims brought by a third party against it or its affiliates
                arising out of or in connection with a breach of any of the
                warranties.
              </p>

              <h2>11. Additional Provisions</h2>
              <p>
                Luv Films has the right to temporarily suspend or terminate the
                contract with You with immediate effect if there are reasons to
                suspect that You have violated the Terms or any applicable laws,
                rules and regulations or, additionally, if user is otherwise
                using the Platform in a way that may cause damage to Luv Films
                or any third party.
              </p>

              <p>
                If You are dissatisfied with our Platform, the materials
                available on it, or with these Terms, Your sole and exclusive
                remedy is to discontinue accessing or using the Platform.
              </p>

              <p>
                These Terms are governed by and construed in accordance with the
                laws of Republic of India. You waive any claims that You might
                have against Luv Films based on any other jurisdiction including
                Your own.
              </p>

              <p>
                If any provision of these Terms shall be unlawful, void or for
                any reason unenforceable, then that provision shall be deemed
                severable from these Terms and shall not affect the validity and
                enforceability of any remaining provisions.
              </p>

              <p>
                The provisions of these Terms, which by their nature should
                survive the termination of these Terms, shall survive such
                termination.
              </p>

              <p>
                No waiver of any provision of these Terms by us shall be deemed
                a further or continuing waiver of such provision or any other
                provision, and our failure to assert any right or provision
                under these Terms shall not constitute a waiver of such right or
                provision.
              </p>

              <p>
                These Terms of Use, and any rights and licenses granted
                hereunder, may not be transferred or assigned by You, but may be
                assigned by Luv Films without restriction.
              </p>

              <p>
                Please read the conditions of use carefully before using our
                Platform. By using our Platform, You signify Your agreement to
                be bound by these conditions.
              </p>

              <h2>12. Force Majeure</h2>
              <p>
                Luv Films shall not be liable to You for any breach of its
                obligations or termination under these Terms arising from causes
                beyond its reasonable control, including, but not limited to,
                pandemics, fires, and other acts of God, terrorism, strikes,
                delay caused by transport disputes, Government orders or
                regulations.
              </p>

              <h2>13. Grievance Officer</h2>
              <p>
                The name and contact details of Our Grievance Officer/customer
                care are as follows:
              </p>
              <p>
                <strong>Name:</strong> Vicky Sidana
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:casting@luvfilms.in">casting@luvfilms.in</a>
              </p>
              <p>
                The Grievance Officer/customer care can be contacted to report
                abuse, or to complain against any content hosted, transmitted,
                published, updated or shared on the Platform.
              </p>
            </MainContent>
          </TermsContainer>
        </>
      </DocumentTitle>

      <DocumentTitle title={"Privacy Policy"}>
        <>
          <Helmet>
            <link rel="stylesheet" type="text/css" href="css/styles.css" />
          </Helmet>
          <TermsContainer>
            <section id="logo-home">
              <img
                src={YRFLogo}
                style={{ height: "250px", width: "250px", borderRadius: "5px" }}
              />
            </section>
            <HeaderSection>
              {/* <img
                src={YRFLogo}
                alt="Luv Films Logo"
                style={{ height: "200px" }}
              /> */}
              <h1>PRIVACY POLICY</h1>
            </HeaderSection>

            <MainContent>
              <p>
                The service/ platform currently branded as{" "}
                <strong>Luv Films Casting</strong> ("Platform") which is owned,
                operated and managed by <strong>Luv Films LLP</strong>{" "}
                ("Company") that is being accessed and used by you, the user
                ("you/ your/ User") of the Platform, is committed to protecting
                the privacy of its Users.
              </p>
              <p>
                By accessing the Platform, you signify your agreement to accept
                this privacy policy ("Policy"). If you do not agree with any of
                the following terms of this Policy, please do not access the
                Platform and/ or use its services.
              </p>
              <p>
                This Policy is subject to change/ amendments/ modifications/
                alterations based on changes in the legal requirements,
                business, regulatory changes and the updated Policy shall be
                accessible to you on the Platform and shall be effective from
                the moment of availability of such updated Policy on the
                Platform, from time to time. Your continued use of the Platform
                pursuant to any change in the Policy shall be deemed an
                acceptance of the Policy. The Platform hereby encourages the
                User to view the Policy periodically to keep updated with any
                changes made to the Policy. Any such change in the Policy which
                materially lessens the Platform's commitment to you shall be
                communicated to you via prominent notices or other appropriate
                means.
              </p>
              <p>
                This Policy explains how and why the Platform uses personal data
                [also known as personal information and/ or personally
                identifiable information ("PII")]. Examples of PII are as
                follows: (i) passwords; (ii) personal information; (iii) email
                address; and (iv) any national methods of identification;(v)
                social media links.
              </p>
              <p>
                However, the User must note that any information that is freely
                available or accessible in public domain or furnished under the
                Right to Information Act, 2005 or any other law for the time
                being in force shall not be regarded as PII for the purposes of
                this Policy and the Platform shall not be obliged to take any
                measures to protect any information that is freely available in
                the public domain.
              </p>
              <p>
                1.The Platform does not knowingly collect PII from individuals
                who are under the minimum required ages specified herein. You
                must be at least 18 years old or the age of majority in your
                jurisdiction, whichever is greater, to use the Platform.
                Individuals under the applicable age may use the Platforms only
                through a parent or legal guardian's account and with their
                involvement.
              </p>
              <h2>2. Collection: What kind of data/ PII is collected?</h2>
              <p>
                a. Account information/ information provided by you The
                information provided by you while creating an account to access
                the Platform, including but not limited to your PII and/ or data
                provided by you/ volunteered to be provided by you while
                accessing and using the Platform may be collected by the
                Platform.
              </p>

              <p>
                b. Information from affiliates- The Platform may collect
                information from third party companies that you are in
                association with/ in affiliation with/ in a relationship with
                ("Affiliates"). These Affiliates may include your internet
                service provider, mobile phone carriers, other companies who
                provide services to you in relation with the Platform (payment
                gateways, internet browsers), etc. Such information collected by
                Affiliates would include: (i) search queries and commands
                applicable to the Platform made through Affiliate devices or
                voice assistants; (ii) device IDs and unique identifiers like
                user interface information, the Platform registration user
                experience, etc.; and (iii) Platform activation system including
                but not limited to contact information.
              </p>
              <h3></h3>
              <p>
                c. Other information: Any and all information collected from
                other sources in relation to the Platform including but not
                limited to (i) service providers that help the Platform
                determine a location based on your IP address in order to
                customize the Platform for you and for any other uses consistent
                with this Policy; (ii) security service providers that provide
                the Platform with information to secure the Platform's systems,
                prevent fraud and help the Platform protect the security of the
                Users accounts; (iii) payment service providers that provide the
                Platform with payment or balance information, or updates to that
                information, based on their relationship with you; or (iv)
                publicly-available sources such as publicly available posts on
                social media platforms and information available through public
                databases associating IP addresses with internet service
                providers (ISPs). Please note that the sources of the
                aforementioned information are varying, from time to time.
              </p>
              <p>
                <strong>
                  3. THE PLATFORM SHALL NEVER MANDATE YOU TO PROVIDE YOUR PII/
                  SENSITIVE INFORMATION/ TO THE PLATFORM OR TO ANY AFFILIATE/
                  ANY ENTITY REPRESENTING THE PLATFORM. ANY DISCLOSURE OF
                  SENSITIVE PERSONAL INFORMATION/ DATA SHALL BE AT THE SOLE RISK
                  OF THE USER AND WITHOUT ANY LIABILITY TO THE PLATFORM
                  (INCLUDING ITS ASSIGNEES, LICENSEES, SUB-LICENSEES,
                  AFFILIATES, OFFICERS, DIRECTORS, AND EMPLOYEES).
                </strong>{" "}
                You understand, acknowledge and agree that the Platform or any
                other person/ entity acting on behalf of the Platform shall not
                in any manner be responsible for the authenticity of the
                sensitive personal information, or personal data or any other
                sensitive information provided by you to the Platform. The
                Platform shall not be liable or shall not be held responsible
                for any damage, loss, misuse of your data due to any reason
                attributable to a force majeure event.
              </p>
              <p>
                4.Please note that the Platform or any entity representing the
                Platform shall in no event ask for your sensitive information
                including financial information like debit card/ credit card
                number, financial pin numbers, etc. In the event of your access
                to the Platform requires any type of payment service(s), the
                information related to such third party service/ payment gateway
                shall be collected by such third party services and/ or payment
                gateway engaged by the Platform to facilitate such use by you of
                the Platform and the such data shall not be stored by the
                Platform in any event save and except only to the extent
                necessary. Since such private information shall be processed and
                accessed by such third party payment aggregator, the User is
                encouraged to read the privacy policies of such third party
                services. You acknowledge and agree that the Platform shall not
                be liable for any collection, access and processing of data by
                the payment gateway.
              </p>

              <p>
                <b>Use of information</b>: The Platform uses information to for
                registration and creation of an account on the Platform.
                Verification of User age to ensure that our services are
                appropriately directed to all users, and communicating with you
                regarding updates, events, including casting calls, call-backs,
                scheduled auditions, and submission of further information,
                where necessary.
              </p>
              <h2>5. For example, the Platform uses such information to:</h2>
              <ul>
                <li>
                  Help the Platform to quickly and efficiently respond to
                  inquiries and requests;
                </li>
                <li>
                  Coordinate with Affiliates on making the Platform available to
                  members of the Platform and providing information to non
                  members about the availability of the Platform, based on the
                  specific relationship you have with the Affiliate;
                </li>
                <li>
                  Secure the Platform's systems, prevent fraud and help the
                  Platform protect the security of the Platform's accounts;
                </li>
                <li>
                  Communicate with you concerning the Platform so that the
                  Platform can send you news about the Platform, details about
                  new features and on the Platform, special offers, consumer
                  surveys, and to assist you with operational requests such as
                  password change requests. These communications may be by
                  various methods, such as email, push notifications, text
                  message, online messaging channels such as email.
                </li>
                <li>
                  Complete your Account creation/ registration processes,
                  including providing One Time Password (OTP) on your registered
                  mobile number for activating and/ or logging-in your Account
                  on the Platform.
                </li>
                <li>
                  To gather demographic and device information about the user
                  base as a whole. The Platform may use this information in its
                  advertising services. The Platform may also use such
                  information to measure sales and traffic patterns on the
                  Platform, advertising interactions and effectiveness and
                  advertisement identifiers and general enhancement of the
                  Platform.
                </li>
              </ul>
              <p>
                <b>6. Collection of information:</b> The Platform may use
                certain methods to collect information about your subject to the
                device and/or the browser you access the Platform with/ by and
                at the Platform's sole discretion. Electronic identifiers refer
                to unique digital information that may be associated with your
                device and/or your browser when you access the Platform
                ("Electronic Identifiers").
              </p>
              <p>
                a. The Electronic Identifiers shall include but not limit (i)
                cookies that are small text files that are stored on your device
                (computer, smartphone, tablet, etc.), when you visit/ use/
                access the Platform ("Cookies"); and (ii) other device/
                electronic identifiers may include pixel tags, web beacons,
                local storage, and similar technologies that perform similar
                functions. These Cookies contain information that allows the
                Platform to recognize your device/ browser during subsequent
                visits.
              </p>
              <p>
                b. Such Electronic Identifiers may also store data on your
                device and/ or the browser. Such methods shall/ may attach a
                unique identification ("User ID") to the User and unless the
                User ID is voluntarily identified by you using your registration
                data, the Platform will be unaware of your identity at all
                times. Third party companies may place cookies/ electronic
                identifiers to their advertisements which is beyond the control
                of the Platform and the Platform disclaims any damages/ losses
                arising due to your clicking of such advertisements. The
                Platform may place temporary or permanent Electronic Identifiers
                in your device(s). You have the option to manage and control the
                acceptance of Electronic Identifiers through your browser or
                device settings, the consequences of such management of
                Electronic Identifiers including Cookies shall vary at the sole
                discretion of the Platform. Most web browsers allow you to
                control the use of cookies and other similar technologies,
                including web beacons and pixel tags.
              </p>
              <h3>c. Choosing Electronic Identifiers</h3>
              <ul>
                <li>
                  <strong>To manage Cookies:</strong> You may choose to prevent
                  installation of Cookies through your browser settings and
                  configure your browser to set your cookie preferences.
                </li>
                <li>
                  <strong>To manage the resettable device identifiers:</strong>{" "}
                  To opt out of behavioural ads from the Platform in connection
                  with a resettable device identifier on a mobile device,
                  tablet, or streaming media devices, please configure the
                  appropriate setting on your device in the device settings. You
                  may still see the Platform ads on your device, but they will
                  not be selected based on your likely interests.
                </li>
                <li>
                  <strong>To manage other technologies:</strong> There are a
                  number of ways to exercise choice regarding technologies that
                  are similar to cookies, such as browser storage and plugins
                  (e.g., HTML5, IndexedDB, and WebSQL). For example, many
                  popular browsers provide the ability to clear browser storage,
                  commonly in the settings or preferences area. The users are
                  recommended to see your browser's help function or support
                  area to learn more.
                </li>
              </ul>
              <p>
                By continuing to use the Platform, you consent to the use of
                Cookies and other device identifiers in accordance with this
                Policy. If you do not agree to the use of Electronic
                Identifiers, you should discontinue using the Platform or manage
                your Electronic Identifiers as aforesaid above.
              </p>
              <h2>7. Disclosure of information</h2>
              <p>
                The information available with the Platform in relation to the
                User may be disclosed under the following circumstances:
              </p>
              <ul>
                <li>
                  A. The Platform may share your information among the Company's
                  employees/ representatives.
                </li>
                <li>
                  B. <strong>Service Providers:</strong> The Platform uses other
                  companies, agents or contractors ("Service Providers") to
                  perform services on the Platform's behalf or to assist the
                  Platform with the provision of services to you. For example,
                  the Platform engages Service Providers to provide advertising,
                  security, infrastructure and IT services, to customize,
                  personalize and optimize the Platform, for legal purposes, for
                  payment methods, to provide customer service and to process
                  and administer consumer surveys, etc. In the course of
                  providing such services, these Service Providers may have
                  access to your personal or other information. The Platform
                  does not authorize them to use or disclose your PII except in
                  connection with providing their services and has contracts
                  with them to govern how the personal data may be used.
                </li>
                <li>
                  C. <strong>Affiliates:</strong> As described above, you may
                  have a relationship with one or more of the Platform's
                  Affiliates, in which case the Platform may share certain
                  information with them in order to coordinate with them on
                  providing the Platform to members and providing information
                  about the availability of the Platform.
                </li>
                <li>
                  D. <strong>Protection of the Platform and others:</strong> The
                  Platform and its service providers may disclose and otherwise
                  use your personal and other information to locations inside
                  and outside India (as applicable) where the Platform or they
                  reasonably believe such disclosure is needed to (a) satisfy
                  any applicable law, regulation, legal process, or governmental
                  request, (b) enforce applicable terms of use, including
                  investigation of potential violations thereof, (c) detect,
                  prevent, or otherwise address illegal or suspected illegal
                  activities (including payment fraud), security or technical
                  issues, or (d) protect against harm to the rights, property or
                  safety of the Platform, its users or the public, as required
                  or permitted by law. The Platform will share personal data
                  where necessary to establish, exercise or defend the
                  Platform's legal rights.
                </li>
                <li>
                  E. <strong>Business transfers:</strong> In connection with any
                  reorganization, restructuring, merger or sale, or other
                  transfer of assets, the Platform will transfer information,
                  including PII, provided that the receiving party agrees to
                  respect your PII in a manner that is consistent with the
                  Platform's Policy.
                </li>
                <li>
                  F. Whenever in the course of sharing information the Platform
                  transfers PII to other countries, the Platform will ensure
                  that the PII is transferred in accordance with this Policy,
                  with appropriate security measures in place and as permitted
                  by the applicable laws on data protection.
                </li>
                <li>
                  G. Social media:The user and social media subscribers and
                  other individuals may engage with the Platform through
                  third-party social networks (for example, Facebook, X and
                  Pinterest). The Platform may also allow Users to access their
                  accounts through social networks. Where Users or other
                  individuals engage or login through social media, the Platform
                  will share personal data with and receive personal data from
                  the relevant social network. Where Users or individuals engage
                  or login through a social network, the Platform encourages
                  that they read the relevant social network's privacy policy.
                </li>
                <li>
                  H. You may also choose to disclose your information in the
                  following ways: (i) certain portions of the Platform may
                  contain a tool which gives you the option to share information
                  by email, text message and social or other sharing
                  applications, using the applications on your smart device; and
                  (ii) social plugins and similar technologies allow you to
                  share information. Social plugins and social applications are
                  operated by the social networks themselves, and are subject to
                  their terms of use and privacy policies.
                </li>
              </ul>

              <p>
                8. The Platform uses commercially reasonable security measures,
                practices, methods and procedures, at the minimum, mandated
                under the Information Technology Act, 2000 as amended and read
                with Information Technology (Reasonable Security Practices and
                Sensitive Personal Data or Information) Rules, 2011, to
                safeguard and protect your information and data. Such measures
                are implemented by the Platform to protect any unauthorised
                access to and unlawful interception of PII. You accept,
                acknowledge and confirm that there is an inherent security risk
                of providing any kind of information over internet/ cellular
                networks and understand and accept that the Platform cannot
                guarantee the absolute security of your information. You agree
                to not hold the Platform responsible for any breach (threatened,
                alleged, or actual) of security or the disclosure of PII. You
                agree that disclosing any information by yourself is solely and
                completely at your own risk.
              </p>

              <p>
                <b>9. Storage of information (if any):</b> The information
                collected shall be stored in an electronic form, primarily,
                however, information may be stored in a physical form as well.
                You agree that the Platform may store, collect, process and use
                your data in locations/ jurisdictions outside the country of
                India and such data will be used in line and in compliance with
                applicable laws.
              </p>
              <p>
                <b>10. Retention of information:</b>
                The Platform shall store your data in full compliance with
                applicable laws and until as necessary to comply with legal
                obligations, enforce the Platform's policies and resolve
                complaints and/ or disputes. The Platform shall delete your
                information upon completion of the purpose of such information
                and shall be deleted in a secure method. For abundant clarity,
                deletion of your information shall exclude anonymous data
                collected through your use/ access of the Platform.
              </p>

              <p>
                <b>11.Access:</b>
                As per the applicable laws, should you wish to request access to
                information collected about you, you may place such request by
                contacting the Platform. The Platform provides with you all
                information that the Platform maintains about you such as the
                contact information, payment (transaction) information upon
                proper verification of the User at the time of request of such
                information. Proper verification shall include the following
                information at the time of contacting the Platform for any kind
                of information: (i) Your physical or electronic signature; and
                (ii) adequate information by which the Platform can contact you.
                You may also request to correct the information collected about
                you by contacting the Grievance Officer (mentioned below) and
                request the deletion of any information collected about you.
                Upon deletion of such information collected about you, you
                agree, acknowledge and confirm that such deletion may result in
                cancellation of your access to/ usage of the Platform and/ or
                certain features of the Platform. You agree and acknowledge that
                certain information collected about you cannot be deleted or
                corrected or prohibited to be deleted as required by any legal
                enforcement agency, under applicable laws and/ or for archival
                purposes.
              </p>
              <p>
                <b>Support: </b> If you have any queries, feedbacks or
                complaints regarding the Policy and/ or Platform, your access to
                the Platform, you may please avail the support and assistance of
                the support chat available on the Platform under 'support'. If
                you have any information, data, complaint, feedback regarding
                any of your information/ PII, please reach out to the Platform
                at <a href="mailto:casting@luvfilms.in">casting@luvfilms.in</a>.
              </p>
              <h2>12. Grievance Officer</h2>
              <p>
                The Grievance Officer is identified below pursuant to the
                provisions of applicable laws including but not limited to the
                Information Technology Act, 2000 and the rules enacted under
                those laws:
              </p>
              <p>
                <strong>Name:</strong> Vicky Sidana
                <br />
                <strong>Email:</strong>{" "}
                <a href="mailto:casting@luvfilms.in">casting@luvfilms.in</a>
              </p>
              <h2>13. Miscellaneous</h2>
              <p>
                This Policy shall be governed by and construed in accordance
                with the laws of India and the Courts at Mumbai shall have
                exclusive jurisdiction regarding any matter arising out of or
                related to this Policy.
              </p>
              <p>
                Each affiliate of the Platform is severally liable for its own
                obligations under this Policy and is not jointly liable for the
                obligations of other affiliates of the Platform. In addition,
                each affiliate of the Platform is solely responsible with
                respect to its exercise of its rights and compliance with its
                obligations in connection with the territory or territories for
                which it is responsible, as determined by the Platform in its
                sole discretion.
              </p>
              <p>
                If any provision of this Agreement is adjudged by a court to be
                void or unenforceable, the same shall in no way affect any other
                provision of this Agreement, or its validity or enforceability
                and the unenforceable provision shall be performed to the extent
                valid and enforceable.
              </p>
            </MainContent>
          </TermsContainer>
        </>
      </DocumentTitle>
    </>
  );
};

export default TermsCondition;
